import { createRouter, createWebHistory } from "vue-router";
import { ensureLocale } from "../i18n";
import { getCurrentLocale, getCurrentRegion } from "../util/route";

// Routes
import GameServer from "../components/GameServer.vue";
import NotFound from "../components/NotFound.vue";

export const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    // dynamic segments start with a colon
    { name: "gameserver", path: "/:region/:locale/service/:serviceId(\\d+)/:tabSegments*", component: GameServer },
    {
      name: "gameserverWi",
      path: "/:wiRegion/server/:controllerSlug/:gameserverId(\\d+)/:tabSegments*",
      component: GameServer,
    },
    { name: "notfound", path: "/:pathMatch(.*)*", component: NotFound },
  ],
});

router.beforeEach(async (to) => {
  if (to.name === "gameserver" || to.name === "gameserverWi") {
    // validate region
    if (!getCurrentRegion(to)) {
      return { name: "notfound", replace: true };
    }
    // i18n (general) locale loading
    await ensureLocale(getCurrentLocale(to));
  }
});
